/* =========================================================================
   INO x Horizon - ino-circle.js
   Behavior for the Circle page's interactive studio map (ino-circle-network).
   - Idempotent + theme-editor safe (re-wires on shopify:section:load).
   - Defensive: every node guarded; missing elements never throw.
   - Reveal-on-scroll (.ino-reveal -> .in) and the nav scroll state are owned by
     ino-home.js, which also loads on this template. The .in class it adds to the
     network section triggers the CSS map draw-in; this file only wires the
     card <-> pin <-> crosshair <-> coordinate sync and the parallax float.
   ========================================================================= */
(function () {
  "use strict";

  function eachNetwork(scope, cb) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches(".ino-circle-network")) cb(root);
    var found = root.querySelectorAll(".ino-circle-network");
    for (var i = 0; i < found.length; i++) cb(found[i]);
  }

  function initNetwork(net) {
    if (net.dataset.inoCircleBound) return;
    net.dataset.inoCircleBound = "1";

    var pts = Array.prototype.slice.call(net.querySelectorAll(".pt"));
    var cards = Array.prototype.slice.call(net.querySelectorAll(".s-card"));
    var cv = net.querySelector(".cross-v");
    var ch = net.querySelector(".cross-h");
    var roVal = net.querySelector("[data-ro-val]");
    var plane = net.querySelector(".plane");
    var inner = net.querySelector(".map-inner");

    function setActive(id) {
      if (id == null) return;
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var on = p.dataset.s === id;
        p.classList.toggle("on", on);
        if (on) {
          if (cv) cv.style.left = p.style.left;
          if (ch) ch.style.top = p.style.top;
          if (roVal) roVal.innerHTML = p.dataset.coord || "";
        }
      }
      for (var j = 0; j < cards.length; j++) {
        cards[j].classList.toggle("active", cards[j].dataset.s === id);
      }
      if (cv) cv.classList.add("show");
      if (ch) ch.classList.add("show");
    }

    function bindSync(el) {
      el.addEventListener("mouseenter", function () { setActive(el.dataset.s); });
      el.addEventListener("focus", function () { setActive(el.dataset.s); });
      el.addEventListener("click", function (e) {
        /* Pins never navigate; cards that are real links keep their default. */
        if (el.classList.contains("pt") && e) e.preventDefault();
        setActive(el.dataset.s);
      });
    }
    for (var a = 0; a < pts.length; a++) bindSync(pts[a]);
    for (var b = 0; b < cards.length; b++) bindSync(cards[b]);

    /* Subtle parallax - the map floats above the grid. */
    var reduce = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (plane && inner && !reduce) {
      plane.addEventListener("mousemove", function (e) {
        var r = plane.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var dx = (e.clientX - r.left) / r.width - 0.5;
        var dy = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = "translate(" + (dx * -9) + "px," + (dy * -9) + "px)";
      });
      plane.addEventListener("mouseleave", function () {
        inner.style.transform = "";
      });
    }

    /* Mobile: when the cards collapse into a horizontal swipe row, update the
       map to whichever card is centered as you scroll - the touch analog of the
       desktop hover. No-op on desktop (the grid is not horizontally scrollable).
       Guarded throughout so it can never throw. */
    var cardsWrap = net.querySelector(".cards");
    if (cardsWrap && cards.length) {
      var syncPending = false;
      var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 80); };
      cardsWrap.addEventListener("scroll", function () {
        if (syncPending) return;
        syncPending = true;
        raf(function () {
          syncPending = false;
          if (cardsWrap.scrollWidth - cardsWrap.clientWidth < 8) return; /* not a swipe row */
          var wrapRect = cardsWrap.getBoundingClientRect();
          var mid = wrapRect.left + wrapRect.width / 2;
          var best = null, bestDist = Infinity;
          for (var k = 0; k < cards.length; k++) {
            var r = cards[k].getBoundingClientRect();
            var d = Math.abs((r.left + r.width / 2) - mid);
            if (d < bestDist) { bestDist = d; best = cards[k]; }
          }
          if (best) setActive(best.dataset.s);
        });
      }, { passive: true });
    }

    /* Start on the first studio so the link between cards and map reads. */
    if (pts.length) setActive(pts[0].dataset.s);
  }

  function init(scope) {
    eachNetwork(scope, function (net) {
      try { initNetwork(net); } catch (err) {}
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    init((e && e.target) || document);
  });
})();
